export interface MagentoAddress {}
